export default "__VITE_ASSET__021748b5__"